var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('product-category-path', {
    staticClass: "product-category-hierarchy",
    attrs: {
      "categories": _vm.categories
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de0580ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ProductCategoryHierarchy.vue
// module id = 2121
// module chunks = 0